import React, {FC, useState, useCallback} from 'react'
import debounce from 'lodash/debounce'
import clsx from 'clsx'
import useAxiosPrivate from '../../../../libs/useAxiosPrivate'
import {getPrefTariffSources} from '../core/_requests'

type PrefTariffSourceAutocompleteProps = {
  placeholder: string
  value: string
  onChange: (value: string) => void
  isInvalid?: boolean
  isValid?: boolean
}

const PrefTariffSourceAutocomplete: FC<PrefTariffSourceAutocompleteProps> = ({
  placeholder,
  value,
  onChange,
  isInvalid,
  isValid,
}) => {
  const [suggestions, setSuggestions] = useState<string[]>([])
  const [showDropdown, setShowDropdown] = useState(false)
  const axiosPrivate = useAxiosPrivate()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchSuggestions = useCallback(
    debounce(async (query: string) => {
      if (query.length < 2) {
        setSuggestions([])
        setShowDropdown(false)
        return
      }

      try {
        const res = await getPrefTariffSources(axiosPrivate, { search: query })
        const data = res.data.data.map((item: any) => item.data)
        setSuggestions(data)
        setShowDropdown(data.length > 0)
      } catch (error) {
        console.error('Error fetching suggestions:', error)
      }
    }, 300),
    [axiosPrivate]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.toUpperCase()
    onChange(newValue)
    fetchSuggestions(newValue)
  }

  const handleSelect = (suggestion: string) => {
    onChange(suggestion)
    setShowDropdown(false)
  }

  return (
    <div className='position-relative'>
      <input
        placeholder={placeholder}
        type='text'
        autoComplete='off'
        value={value}
        onChange={handleInputChange}
        onBlur={() => {
          // Small timeout to allow click on dropdown items
          setTimeout(() => setShowDropdown(false), 200)
        }}
        className={clsx('form-control bg-transparent', {
          'is-invalid': isInvalid,
          'is-valid': isValid,
        })}
      />
      {showDropdown && suggestions.length > 0 && (
        <ul
          className='dropdown-menu show w-100'
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li key={index}>
              <button
                className='dropdown-item'
                type='button'
                onClick={() => handleSelect(suggestion)}
              >
                {suggestion}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default PrefTariffSourceAutocomplete
